import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { matchPath, useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';

import { modelOf } from '../../../prop-types';
import UIStore from '../../../store/UIStore';
import Paths from '../../../types/Paths';
import Icon from '../Icon';

const GoBackLink = ({ uiStore }) => {
  const history = useHistory();
  const prefix = '/:locale?/:section?';
  const paths = [
    prefix + Paths.NewProducts,
    prefix + Paths.OnSale,
    prefix + Paths.Category,
    prefix + Paths.Manufacturer,
    '/:locale?' + Paths.Section,
  ];

  const lastPageIsListing = paths.some((path) => {
    return matchPath(uiStore.lastPathname, { path, exact: true });
  });

  if (!lastPageIsListing) {
    return null;
  }

  const lastPageIsCheckout = matchPath(uiStore.lastPathname, {
    path: Paths.Checkout,
    exact: true,
  });

  const getBackButtonText = () => {
    if (lastPageIsCheckout) {
      return null;
    }

    return (
      <FormattedMessage
        id="navigation.goBackLink"
        defaultMessage="Back to search results"
      />
    );
  };

  return (
    <Button
      className="GoBackLink"
      color="link"
      onClick={history.goBack}
      role="link"
    >
      <Icon name="chevron-left" />
      {getBackButtonText()}
    </Button>
  );
};

GoBackLink.propTypes = {
  uiStore: modelOf(UIStore).isRequired,
};

export default inject('uiStore')(observer(GoBackLink));
